const ACCEPTED = 'ACCEPTED';
const WORKER_REQUEST = 'WORKER_REQUEST';
const ALLOCATE = 'ALLOCATE';
const REALLOCATE = 'REALLOCATE';
const ALLOCATE_CANCEL = 'ALLOCATE_CANCEL';
const PICKUP_FINISH = 'PICKUP_FINISH';
const DROP_FINISH = 'DROP_FINISH';
const CANCEL = 'CANCEL';
const UPDATE = 'UPDATE';
/** 주문 이벤트 (배차요청, 즉시배차등) */
const orderEvent = {
    /** 접수 */
    [ACCEPTED]: ACCEPTED,
    /** 배차 요청 */
    [WORKER_REQUEST]: WORKER_REQUEST,
    /** 즉시배차 */
    [ALLOCATE]: ALLOCATE,
    /** 재배차 */
    [REALLOCATE]: REALLOCATE,
    /** 배차 취소 */
    [ALLOCATE_CANCEL]: ALLOCATE_CANCEL,
    /** 픽업 완료 */
    [PICKUP_FINISH]: PICKUP_FINISH,
    /** 배달 완료 */
    [DROP_FINISH]: DROP_FINISH,
    /** 취소 */
    [CANCEL]: CANCEL,
    /** 업데이트 */
    [UPDATE]: UPDATE,
};
export default orderEvent;
